export default "__VITE_ASSET__BYrA1NgY__"